module.exports = "/assets/data/7319c1f2f03b02ee0a52e8a261dd3e2c-M20.data.json";